"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.patrimonyBalanceImpressionsList = void 0;
const io_1 = require("react-icons/io");
const fa_1 = require("react-icons/fa");
const md_1 = require("react-icons/md");
const React = require("react");
const general_impression_config_1 = require("../config/general-impression.config");
exports.patrimonyBalanceImpressionsList = [
    {
        id: 0,
        title: 'Patrimonio',
        subtitle: 'Bem gerenciado',
        description: 'Foi detectado que a empresa sabe lidar com seus ativos e passivos, sempre priorizando adquirir mais ativos que passivos e em todas as demonstrações sempre estiveram melhores, muito bom.',
        icon: React.createElement(io_1.IoIosBusiness, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.nice,
        importantLevel: 80,
        reportableIdentification: 'BOM_GERENCIAMENTO_PATRIMONIO',
    },
    {
        id: 1,
        title: 'Saindo',
        subtitle: 'do vermelho',
        description: 'Foi detectado que a empresa tem alguns problemas em gerenciar seus ativos e passivos, porém com o passar dos anos ela está resolvendo eles muito bem, futuramente pode dar muito lucro!',
        icon: React.createElement(fa_1.FaBusinessTime, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.warning,
        importantLevel: 85,
        reportableIdentification: 'EMPRESA_SAINDO_DO_VERMELHO',
    },
    {
        id: 2,
        title: 'Patrimonio',
        subtitle: 'INSTÁVEL',
        description: 'Foi detectado que a empresa tem problemas no seu patrimonio, mantendo mais passivos que ativos, tome cuidado se deseja comprar e manter ações dela a longo prazo.',
        icon: React.createElement(md_1.MdBusiness, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.warning,
        importantLevel: 85,
        reportableIdentification: 'PATRIMONIO_INSTAVEL',
    },
];
//# sourceMappingURL=patrimony-balance-impressions.data.js.map